// This is a way to work with MST action syntax
// The input argument has to match the api and the result
// is a literal object type which is compatible with the ModelActions
// type that is required by MST.
/**
 * A TypeScript helper method for adding hooks to a content model. It should be
 * used like:
 * ```
 * .actions(self => tileContentAPIActions({
 *   // add your hook functions here
 * }))
 * ```
 * @param clientHooks the hook functions
 * @returns the hook functions in a literal object format that is compatible
 * with the ModelActions type of MST
 */
export function tileContentAPIActions(clientHooks) {
    const hooks = Object.assign({ doPostCreate(metadata) {
            // no-op
        },
        onTileAction(call) {
            // no-op
        },
        willRemoveFromDocument() {
            // no-op
        },
        setContentTitle(title) {
            // no-op
        } }, clientHooks);
    return Object.assign({}, hooks);
}
/**
 * A TypeScript helper method for adding standard views to a content model. It should be
 * used like:
 * ```
 * .views(self => tileContentAPIViews({
 *   // add your hook functions here
 * }))
 * ```
 * @param clientViews the views your tile is implementing
 * @returns the views in a literal object format that is compatible
 * with the ModelViews type of MST
 */
export function tileContentAPIViews(clientViews) {
    const defaultHooks = {
        get contentTitle() {
            return undefined;
        },
        get annotatableObjects() {
            return [];
        },
        getObjectsForVariable(_variableId) {
            return [];
        },
    };
    // Using Object.defineProperties is needed so we can correctly copy the getters from the clientViews
    // into the new object
    return Object.defineProperties(defaultHooks, Object.getOwnPropertyDescriptors(clientViews));
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGlsZS1tb2RlbC1ob29rcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9tb2RlbHMvdGlsZXMvdGlsZS1tb2RlbC1ob29rcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFxQ0EsK0NBQStDO0FBQy9DLHlEQUF5RDtBQUN6RCxxRUFBcUU7QUFDckUsZ0NBQWdDO0FBRWhDOzs7Ozs7Ozs7OztHQVdHO0FBQ0gsTUFBTSxVQUFVLHFCQUFxQixDQUFDLFdBQTRDO0lBQ2hGLE1BQU0sS0FBSyxtQkFDVCxZQUFZLENBQUMsUUFBNEI7WUFDdkMsUUFBUTtRQUNWLENBQUM7UUFDRCxZQUFZLENBQUMsSUFBMkI7WUFDdEMsUUFBUTtRQUNWLENBQUM7UUFDRCxzQkFBc0I7WUFDcEIsUUFBUTtRQUNWLENBQUM7UUFDRCxlQUFlLENBQUMsS0FBYTtZQUMzQixRQUFRO1FBQ1YsQ0FBQyxJQUNFLFdBQVcsQ0FDZixDQUFDO0lBQ0YseUJBQVcsS0FBSyxFQUFFO0FBQ3BCLENBQUM7QUEyQkQ7Ozs7Ozs7Ozs7O0dBV0c7QUFDSCxNQUFNLFVBQVUsbUJBQW1CLENBQUMsV0FBMEM7SUFDNUUsTUFBTSxZQUFZLEdBQXlCO1FBQ3pDLElBQUksWUFBWTtZQUNkLE9BQU8sU0FBUyxDQUFDO1FBQ25CLENBQUM7UUFDRCxJQUFJLGtCQUFrQjtZQUNwQixPQUFPLEVBQUUsQ0FBQztRQUNaLENBQUM7UUFDRCxxQkFBcUIsQ0FBQyxXQUFtQjtZQUN2QyxPQUFPLEVBQUUsQ0FBQztRQUNaLENBQUM7S0FDRixDQUFDO0lBRUYsb0dBQW9HO0lBQ3BHLHNCQUFzQjtJQUN0QixPQUFPLE1BQU0sQ0FBQyxnQkFBZ0IsQ0FBQyxZQUFZLEVBQUUsTUFBTSxDQUFDLHlCQUF5QixDQUFDLFdBQVcsQ0FBQyxDQUFDLENBQUM7QUFDOUYsQ0FBQyJ9